import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import api from "../../constants/api";

export const doCompaniesSearch = createAsyncThunk(
	'companies/getCompanies',
	async ({ searchString, countryCode, recaptchaToken }) => {
		return await api.searchForCompany(searchString, countryCode, recaptchaToken);
	}
);

const initialState = {
	loading: false,
	companies: null,
	error: null,
};

const companiesSlice = createSlice({
    name: "companies",
    initialState,
    reducers: {

    },
	extraReducers: {
    	[doCompaniesSearch.pending]: (state) => {
    		state.loading = true;
			state.error = null;
		},
		[doCompaniesSearch.rejected]: (state, {payload}) => {
    		state.loading = false;
    		state.error = payload;
    		state.companies = null;
		},
		[doCompaniesSearch.fulfilled]: (state, {payload}) => {
			state.loading = false;
			state.companies = payload;
		}
	}
});

export const selectIsLoading = (state) => state.companies.loading;
export const selectCompanies = (state) => state.companies.companies;

export default companiesSlice.reducer;
